import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { User } from 'lucide-react';
import { feedItemAvatars, feedItemBodyHtml } from 'utils/KnockFeedUtils';
import sanitizeFeedHtml from 'utils/sanitizeFeedHtml';
var BannerAvatar = function (_a) {
    var url = _a.url, alt = _a.alt;
    return (url ? (_jsx("img", { src: url, alt: alt, "aria-hidden": "true", className: "h-8 w-8 rounded-full border-2 border-white object-cover" })) : (_jsx("span", { "aria-hidden": "true", title: alt, className: "flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-white/20", children: _jsx(User, { className: "h-4 w-4" }) })));
};
/**
 * The persistent AI Coach banner (launch requirement, locked 2026-07-02):
 * flashes across the top of whatever screen the producer is on, persists until
 * tapped, first tap acknowledges (Knock `markAsInteracted`) and clears it on
 * EVERY surface — first-acknowledgment-wins is the desired behavior ("the tap
 * means I heard you"). Two-avatar treatment: coach + producer, from the
 * workflow payload. No retained history here; the bell keeps the day-view.
 *
 * Fixed positioning anchors it to the viewport, so one component serves the
 * player area (desktop web) and the mobile entry (which the iOS shell wraps in
 * a webview) without caring where it mounts. It sits just BELOW the header —
 * both the shared player/coach header and the mobile `.sb-app-header` are
 * 54px fixed-top. At top-0 it covered the header and click-blocked the bell,
 * nav, and account menu until acknowledged, which made the bell's "Got it"
 * unreachable whenever it existed (any un-acked item banners).
 */
var ProducerNudgeBanner = function (_a) {
    var item = _a.item, onAcknowledge = _a.onAcknowledge;
    var _b = feedItemAvatars(item), producerAvatarUrl = _b.producerAvatarUrl, coachAvatarUrl = _b.coachAvatarUrl;
    // No aria-label on the button: it would REPLACE the accessible name and
    // hide the coaching message from assistive tech — the name is the rendered
    // message body plus the "Tap to dismiss" hint (avatars are decorative,
    // aria-hidden).
    return (_jsxs("button", { type: "button", onClick: onAcknowledge, className: "fixed inset-x-0 top-[54px] z-[100] flex w-full items-center gap-3 border-0 bg-dark-slate px-4 py-3 text-left text-white shadow-lg", children: [_jsxs("span", { className: "flex shrink-0 -space-x-2", children: [_jsx(BannerAvatar, { url: coachAvatarUrl, alt: "Your coach" }), _jsx(BannerAvatar, { url: producerAvatarUrl, alt: "You" })] }), _jsx("span", { className: "min-w-0 flex-1 text-sm [&_p]:m-0", dangerouslySetInnerHTML: {
                    __html: sanitizeFeedHtml(feedItemBodyHtml(item.blocks))
                } }), _jsx("span", { className: "shrink-0 text-xs opacity-70", children: "Tap to dismiss" })] }));
};
export default ProducerNudgeBanner;
